import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import UserService from "../api/UserService"
import './DocumentsDS.css'
import { base_url } from '../api/index'
import { getRegions, getAllDSUsers } from '../actions/dictionary'

function DocumentsDS({ user, regions, users_ds, getRegions, getAllDSUsers }) {
    const userStatus = user.status
    const isUserConfirmed = userStatus === 'confirmed' ? true : false
    const [msg, setMsg] = useState('Страница доступна только авторизованным пользователям')
    const [districts, setDistricts] = useState([
        { name: 'Дальневосточный федеральный округ', collapsed: true },
        { name: 'Приволжские федеральный округ', collapsed: true },
        { name: 'Северо-Западный федеральный округ', collapsed: true },
        { name: 'Северо-Кавказский федеральный округ', collapsed: true },
        { name: 'Сибирский федеральный округ', collapsed: true },
        { name: 'Уральский федеральный округ', collapsed: true },
        { name: 'Центральный федеральный округ', collapsed: true },
        { name: 'Южный федеральный округ', collapsed: true }
    ])

    const [Regions, setRegions] = useState([])
    const [users, setUsers] = useState([])


    useEffect(() => {
        // if (isUserConfirmed) {
            if (regions.length === 0)
                getRegions()
            if (users_ds.length === 0)
                getAllDSUsers()
        // }
    }, [])

    useEffect(() => {
        const mas = []
        if (regions.length > 0 && users.length > 0) {
            regions.forEach(region => {
                const isContainUser = users.findIndex(val => val.region === region.name) >= 0 ? true : false
                let district
                let district_code = null
                try {
                    district_code = +region.object.A2372570o30570o63222o16383o086194.o11.match(/\d+/)[0]
                } catch (e) { }
                switch (district_code) {
                    case 1:
                        district = districts[6].name
                        break
                    case 2:
                        district = districts[2].name
                        break
                    case 3:
                        district = districts[1].name
                        break
                    case 4:
                        district = districts[7].name
                        break
                    case 5:
                        district = districts[3].name
                        break
                    case 6:
                        district = districts[5].name
                        break
                    case 7:
                        district = districts[4].name
                        break
                    case 8:
                        district = districts[0].name
                        break
                    default:
                        district = null
                        break
                }
                mas.push({
                    key: region.id,
                    name: region.name,
                    district,
                    collapsed: true,
                    isContainUser
                })
            })
        }
        setRegions(mas.sort((a, b) => a.name > b.name))
    }, [regions, users])

    useEffect(() => {
        const mas = []
        if (users_ds.length > 0) {
            users_ds.forEach(user => {
                let region = null
                let name = null
                try {
                    region = user.object.ae9dd1b1032daaed7cc9638180dc6318b.region.value
                    name = user.object.ae9dd1b1032daaed7cc9638180dc6318b.Company.value
                } catch(e) { }
                mas.push({
                    key: user.id,
                    src: `https://hcvf.ru/info_ds?uid=${user.id}`,
                    name,
                    region
                })
            })
        }
        setUsers(mas.sort((a, b) => a.name > b.name))
    }, [users_ds])


    const districtClick = i => {
        if (!districts[i].collapsed) {
            const new_regions = Regions.map(val => Object.assign({}, val, { collapsed: val.district === districts[i].name ? true : val.collapsed }))
            setRegions(new_regions)
        }
        const new_districts = [...districts]
        new_districts[i].collapsed = !new_districts[i].collapsed
        setDistricts(new_districts)
    }

    const regionClick = name => {
        const new_regions = [...Regions]
        const index = Regions.findIndex(val => val.name === name)
        new_regions[index].collapsed = !new_regions[index].collapsed
        setRegions(new_regions)
    }

    return (
        <>
            {/*isUserConfirmed &&*/ Regions.length > 0 && users.length > 0 &&
                <section className='documents-ds'>
                    <p style={{ lineHeight: '22px' }}>В данном разделе размещены документы компаний держателей сертификата FSC. Для перехода к странице
                        с информацией о конкретной компании необходимо выбрать регион и область.
                    </p>

                    <div style={{ marginTop: '24px' }}>
                        {
                            districts.map((district, i) => {
                                return (
                                    <>
                                        <p key={String(i)} className='document-ds__district' onClick={() => districtClick(i)}>
                                            {district.name}
                                        </p>
                                        {!district.collapsed && Regions.filter(val => val.district === district.name).map(region => {
                                            return (
                                                <>
                                                {region.isContainUser ?
                                                    <p key={region.key} className='document-ds__region' onClick={() => regionClick(region.name)}>{region.name}</p>
                                                    :
                                                    <p key={region.key} className='document-ds__region-err'>{region.name}</p>
                                                }
                                                {!region.collapsed && users.filter(val => val.region === region.name).map(user => {
                                                    return (
                                                        <a target='_blank' href={user.src} key={user.key} className='document-ds__user'>{user.name}</a>
                                                    )
                                                })}
                                                </>                                                
                                            )
                                        })}
                                    </>
                                )
                            })
                        }
                    </div>
                </section>
            }
            {/* {userStatus === "unregistered" &&
                <p>{msg}</p>
            } */}
            {/* {isUserConfirmed && role !== 'e249a07138dd45d3f4ba27d90d6c2244d' &&
                <p>Страница доступна только пользователям роли 'Держатель сертификата FSC'</p>} */}
            {/* {userStatus === 'unregistered' &&
                <p>Страница доступна только авторизованным пользователям</p>} */}
        </>
    )
}

const mapStateToProps = state => ({
    user: state.user,
    regions: state.dictionary.regions,
    users_ds: state.dictionary.users_ds
})

export default connect(mapStateToProps, { getRegions, getAllDSUsers })(DocumentsDS)